import MultiStepForm from './MultiStepForm';

export const multiStepFormListener = () => {
    const formElements = [...document.querySelectorAll('form.js-multi-step-form')].filter(
        (el) => !el.dataset.multiStepFormInitialized
    );

    formElements.forEach((el) => {
        el.multiStepForm = new MultiStepForm({ formContainer: el });

        el.dataset.multiStepFormInitialized = true;
    });
};
